export function userHasRole(user, role) {
  const {roles} = user
  return typeof roles !== "undefined" && roles.length && roles.indexOf(role) !== -1;
}